@if (mode === 'dropdown') {
  @if (user$ | async; as user) {
    <div class="dropdown dropdown-end z-[1100]">
      <button
        type="button"
        tabindex="0"
        class="btn btn-ghost btn-sm h-10 gap-2 rounded-full border-none py-1 pr-2.5 pl-1 normal-case shadow-none"
        [class.account-trigger]="tone === 'default'"
        [class.account-trigger--overlay]="tone === 'overlay'"
        aria-label="Account menu"
      >
        <gb-header-user-profile [user]="user" size="sm" [tone]="tone"></gb-header-user-profile>
        <ui-icon
          name="chevron-down"
          [size]="14"
          class="opacity-60"
          [class.text-white]="tone === 'overlay'"
        ></ui-icon>
      </button>
      <ul
        tabindex="0"
        class="dropdown-content z-[1100] mt-2 flex w-72 flex-col rounded-3xl border border-base-200 bg-base-100 p-2 pb-3 text-base-content shadow-xl"
      >
        <li class="px-3 pt-2 pb-1">
          <gb-header-user-profile [user]="user" size="md"></gb-header-user-profile>
        </li>
        <li [class]="dividerClass"></li>
        <ng-container
          *ngTemplateOutlet="sharedLinks; context: { closeOnNav: false }"
        ></ng-container>
      </ul>
    </div>
  } @else if (isUserLoading) {
    <gb-header-user-profile [user]="" [isLoading]="true" size="sm"></gb-header-user-profile>
  } @else if (showSignIn) {
    <ui-button variant="neutral" [block]="blockSignIn" (buttonClick)="goToLogin()">
      {{ signInLabel }}
    </ui-button>
  }
} @else {
  @if (user$ | async; as user) {
    <div class="mb-3 flex w-full items-center gap-3 px-3">
      <gb-header-user-profile [user]="user" size="md"></gb-header-user-profile>
    </div>
    <ul class="flex w-full flex-col">
      <ng-container *ngTemplateOutlet="sharedLinks; context: { closeOnNav: true }"></ng-container>
    </ul>
  } @else if (isUserLoading) {
    <div class="mb-3 flex w-full items-center gap-3 px-3">
      <gb-header-user-profile [user]="" [isLoading]="true" size="md"></gb-header-user-profile>
    </div>
  } @else if (showSignIn && showUnauthenticatedCta) {
    <ui-button variant="primary" [outline]="true" [block]="true" (buttonClick)="goToLogin()">
      {{ signInLabel }}
    </ui-button>
  }
}

<ng-template #sharedLinks let-closeOnNav="closeOnNav">
  <li>
    <a
      [class]="rowClass + hoverClass"
      [routerLink]="AppRoutes.dashboard.overview()"
      (click)="closeOnNav && onNavigate()"
    >
      <span class="flex w-9 shrink-0 justify-center">
        <ui-icon name="layout-dashboard" [size]="20"></ui-icon>
      </span>
      User Dashboard
    </a>
  </li>
  <li class="px-3 pt-1 pb-1.5 text-xs font-semibold text-base-content/50">View dashboard as</li>
  @for (type of dashboardUserTypes; track type) {
    <li>
      <a [class]="rowClass + hoverClass" (click)="setDashboardUserType(type)">
        <span class="flex w-9 shrink-0 justify-center">
          <ui-icon
            [name]="(dashboardUserType$ | async) === type ? 'circle-check' : 'user'"
            [size]="20"
          ></ui-icon>
        </span>
        {{ dashboardUserTypeLabels[type] }}
      </a>
    </li>
  }
  <li [class]="dividerClass"></li>
  @if ((dashboardUserType$ | async) === 'charity') {
    <li>
      <a
        [class]="rowClass + hoverClass"
        [href]="dashboardUrl"
        target="_blank"
        rel="noopener noreferrer"
        (click)="closeOnNav && onNavigate()"
      >
        <span class="flex w-9 shrink-0 justify-center">
          <ui-icon name="external-link" [size]="20"></ui-icon>
        </span>
        {{ NavLinks.charityDashboard.label }}
      </a>
    </li>
  }
  @if (showDiscoverCampaigns) {
    <li>
      <a
        [class]="rowClass + hoverClass"
        [routerLink]="NavLinks.discover.path"
        (click)="closeOnNav && onNavigate()"
      >
        <span class="flex w-9 shrink-0 justify-center">
          <ui-icon name="compass" [size]="20"></ui-icon>
        </span>
        {{ NavLinks.discover.label }}
      </a>
    </li>
  }
  <li [class]="dividerClass"></li>
  <li>
    <a [class]="rowClass + ' text-error hover:bg-error/10'" (click)="logout()">
      <span class="flex w-9 shrink-0 justify-center">
        <ui-icon name="log-out" [size]="20"></ui-icon>
      </span>
      Log Out
    </a>
  </li>
</ng-template>
